/**
 * Mounts the scrollcraft engine, and nothing else.
 *
 * Kept out of theme.liquid so it can be deferred alongside the engine rather
 * than executing inline before it has loaded. Both scripts are `defer`, so
 * they run in document order after parsing: the engine defines
 * window.ScrollCraft, this mounts it.
 */
(function () {
  function go() {
    if (!window.ScrollCraft) return;
    window.ScrollCraft.mount(document.body);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', go, { once: true });
  } else {
    go();
  }
})();
